<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name" v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>

                <v-combobox
                  v-model="item.type"
                  :items="types"
                  item-text="name"
                  item-value="id"
                  label="Tipo*"
                  name="type"
                  data-vv-as="type"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("type") }}</span>

                <v-text-field
                  v-model="item.costo_unitario"
                  label="Costo Unitario"
                  name="costo_unitario"
                  data-vv-as="costo_unitario"
                  v-validate="'required|decimal'"
                  :disabled="isViewModal()"
                ></v-text-field>

                 <v-combobox
                  v-model="item.resource_unit"
                  data-vv-as="Unidad de medida"
                  name="resource_unit"
                  item-text="name"
                  item-value="id"
                  :items="resource_units"
                  label="Unidad de medida"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("resource_unit") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import Constant from "@/constants/sections";

import { generalService } from "@/libs/ws/generalService";

export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      types: [],
      resource_units : []

    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {
    this.loadTypes();
    this.loadComboData();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    loadComboData() {
   
      generalService.query({}, Constant.SECTION_UNITS + "/list_resource_units").then((response) => {
        this.resource_units = response.result;
      });
  
    },

    loadTypes(){ 

      this.service.list_types().then((response) => {
        this.types = response.result;
      });
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;
          const data = {
            id: this.item.id,
            name: this.item.name,
            type: this.item.type,
            costo_unitario: this.item.costo_unitario,
            resource_unit: this.item.resource_unit ? this.item.resource_unit : null,
          };

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se modificó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
                this.loading = false;
              })
              .catch((error) => {
                console.error(error);
                this.loading = false;
              });
          } else {
            this.service
              .create(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se creó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
                this.loading = false;
              })
              .catch((error) => {
                console.error(error);
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>
